export default "__VITE_ASSET__C$wzKqzn__"